import { IMActivity } from '../../../types'
import { ISimplifiedNode } from '../../../../../components/ingestion/IngestedTree'
import { ancillaryItemsToString } from '../../ancillary_content'
import { IM360Parser } from '../../IM360Parser'
import { parseHtmlString } from 'ingestion/nodeCreationHelpers'
import { snakeKabobToTitleCase } from '../../../../../utility'
import { conditionalParagraphWithHeader } from '../../../../nodeCreationHelpers'

export function ancillaryContent({ ancillary_content, narrative }: IMActivity) {
  const annotations = narrativeAnnotations(narrative)
  const sortedKeys = [
    'instructional_routines',
    'mathematical_language_routines',
    'swd_supports',
    'required_materials',
  ]
  const filtered = ['external_infos', 'math_practices']
  return Object.entries(ancillary_content)
    .sort(
      ([keyA], [keyB]) => sortedKeys.indexOf(keyA) - sortedKeys.indexOf(keyB),
    )
    .reduce<ISimplifiedNode[]>((acc, [key, value]) => {
      if (filtered.includes(key)) return acc
      const annotation = annotations.find(([header]) => {
        return value.find(({ title }) => header.includes(title))
      })
      const noteValue = ancillaryItemsToString(undefined, value)
      if (!noteValue) return acc
      const annotationValue = conditionalParagraphWithHeader(
        annotation?.[0] ?? '',
        annotation?.[1],
      )
      return [
        ...acc,
        IM360Parser.getInstance().createNoteNode({
          title: ancillaryTitle(key),
          value: noteValue + annotationValue,
          studentFacing: false,
        }),
      ]
    }, [])
}

function narrativeAnnotations(narrative: string) {
  const asHtml = parseHtmlString(narrative)
  const parentElem = Array.from(asHtml.getElementsByClassName('c-annotations'))

  if (!parentElem.length) return narrativeAnnotationsWithoutList(asHtml)

  return parentElem.reduce<[string, string][]>((acc, annotation) => {
    Array.from(annotation.children)
      .reduce<HTMLElement[]>((acc, child) => {
        if (child.className.includes('c-annotation')) {
          if (!child.children.length) return acc
          return [...acc, child as HTMLElement]
        }
        const last = acc.pop()!
        last.appendChild(child)
        return [...acc, last]
      }, [])
      .forEach((child) => {
        const headerElement = child.children.item(0)!
        headerElement.remove()
        acc.push([headerElement.textContent!.trim(), child.outerHTML])
      })
    return acc
  }, [])
}

function narrativeAnnotationsWithoutList(asHtml: Document) {
  const annos = Array.from(asHtml.getElementsByClassName('c-annotation'))
  return annos
    .reduce<HTMLElement[]>((acc, annotation) => {
      if (!annotation.children.length) return acc
      return [...acc, annotation as HTMLElement]
    }, [])
    .map((child) => {
      const headerElement = child.children.item(0)!
      child.removeChild(headerElement)
      return [headerElement.textContent!.trim(), child.outerHTML]
    })
}

function ancillaryTitle(key: string) {
  switch (key) {
    case 'swd_supports':
      return 'Access for Students with Disabilities'
    case 'mathematical_language_routines':
      return 'Access for English Language Learners'
    case 'external_infos':
      return 'Time Frame'
    default:
      return snakeKabobToTitleCase(key)
  }
}
